import React from "react";
import Selector from "../../../Selector";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";

import useStyles from "../../style";

export function FilterAssignOnAdd({
  mainGroup,
  filterAssignOnAdd,
  setAssignOnAdd,
  action
}) {

  const classes = useStyles();

  const filters = [
    { value: 'all', label: 'Todas' },
    { value: 'my_assigned', label: 'Minhas' }
  ];

  return action.indexOf("adicionar-documentos") !== -1 &&
  ["support", "backoffice"].indexOf(mainGroup) !== -1 && (
    <Grid
      item
      xs={12}
      sm={12}
      md={2}
      lg={2}
      className={classes.assignFilter}
    >
      <Selector
        options={filters}
        placeholder="Selecione uma opção"
        data-cy="tabHeader-filterAssin-select"
        id="tabHeader-filterAssinOnAdd-select"
        label='Responsável'
        width='250px'
        isClearable
        isMulti
        value={filterAssignOnAdd}
        onChange={setAssignOnAdd}
        isOptionDisabled={(option) =>
          {
            if (filterAssignOnAdd.length === 0) {
              return false;
            }

            if(filterAssignOnAdd.some(selectedOption => selectedOption.value === 'all')) {
              if (option.value !== 'all') {
                return true;
              }
            } else {
              if (option.value === 'all') {
                return true;
              }
            }
          }
       }
      />
    </Grid>
  )
}

const mapState = (state) => ({
  filterAssignOnAdd: state.loadingOrders.filterAssignOnAdd
});

const mapDispatch = (dispatch) => ({
  setAssignOnAdd: (payload) => dispatch.loadingOrders.setAssignFilterOnAdd(payload)
});

export default connect(mapState, mapDispatch)(FilterAssignOnAdd);
